import axiosInstance from '../api/axiosInstance';

/**
 * supplierService — All Supplier API calls
 *
 *  GET    /Suppliers         → list all suppliers
 *  PUT    /Suppliers/{id}    → update a supplier
 *  DELETE /Suppliers/{id}    → delete a supplier
 */

// Get all suppliers
export const getSuppliers = (params) => {
  return axiosInstance.get('/Suppliers', { params }).then((res) => res.data);
};

// Get a single supplier by ID
export const getSupplier = (id) => {
  return axiosInstance.get(`/Suppliers/${id}`).then((res) => res.data);
};

// Create a new supplier
export const createSupplier = (data) => {
  return axiosInstance.post('/Suppliers', data).then((res) => res.data);
};

// Update an existing supplier
export const updateSupplier = (id, data) => {
  return axiosInstance.put(`/Suppliers/${id}`, data).then((res) => res.data);
};

// Delete a supplier
export const deleteSupplier = (id) => {
  return axiosInstance.delete(`/Suppliers/${id}`).then((res) => res.data);
};
